import { useState, useEffect } from 'react'
import { InputModel } from '../../../../../utils/types'
import { Item } from '../../../../../utils/types/generals'
import { Roles } from '../../../../../utils/enums'

const useInput = ({ items }: { items?: { [x: string]: Item[] } }) => {
  const [input, setInput] = useState<{ [x: string]: InputModel }>({
    search: {
      label: 'userGroup.filter.search',
      translate: true,
      name: 'search',
      rest: {
        type: 'alphaNumeric',
      },
      value: null,
    },
    createYear: {
      label: 'general.filterDate.year',
      translate: true,
      name: 'createYear',
      type: 'filter-select',
      items: items?.createYears ?? [],
      value: null,
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6,
      },
    },
    month: {
      label: 'general.filterDate.month',
      translate: true,
      name: 'month',
      type: 'filter-select',
      items: items?.monthYear ?? [],
      value: null,
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6,
      },
    },
    from: {
      label: 'general.tags.from',
      translate: true,
      name: 'from',
      type: 'date',
      value: null,
      rest: {
        max: 'to',
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6,
      },
    },
    to: {
      label: 'general.tags.to',
      translate: true,
      name: 'to',
      type: 'date',
      value: null,
      rest: {
        min: 'from',
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6,
      },
    },
    roles: {
      label: 'general.tags.role',
      translate: true,
      name: 'roles',
      type: 'filter-select',
      items: items?.roles ?? [],
      value: null,
      notAllowedRoles: [Roles.AGENT, Roles.AUDIT],
    },
    userId: {
      label: 'general.tags.user',
      translate: true,
      name: 'userId',
      type: 'filter-select',
      items: items?.userId ?? [],
      value: [],
      notAllowedRoles: [Roles.AGENT, Roles.AUDIT],
    },
    userTypeId: {
      label: 'general.tags.userType',
      translate: true,
      name: 'userTypeId',
      type: 'filter-select',
      items: items?.userTypeId ?? [],
      value: [],
      notAllowedRoles: [Roles.AGENT, Roles.AUDIT],
    },
    divisions: {
      label: 'general.tags.division',
      translate: true,
      name: 'divisions',
      type: 'filter-select',
      items: items?.divisions ?? [],
      value: null,
      notAllowedRoles: [Roles.AGENT, Roles.AUDIT],
    },
    area: {
      label: 'general.tags.area',
      translate: true,
      name: 'area',
      type: 'filter-select',
      items: items?.areas ?? [],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
    department: {
      label: 'general.tags.department',
      translate: true,
      name: 'department',
      type: 'filter-select',
      items: items?.departments ?? [],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
  })

  useEffect(() => {
    let body = {}

    Object.entries(input).forEach(([key, itemInputs]) => {
      body = { ...body, [key]: { ...itemInputs, items: items?.[key] } }
    })

    setInput(body)
    // eslint-disable-next-line
  }, [items])

  return { input }
}

export { useInput }
